import styled from "styled-components"
import { ISoftwareSolutionCard } from "../../molecules/SoftwareSolutionCard"
import { AosWrapper } from "../../molecules/AosWrapper"
import { animationProperties } from "../../../utils"
import { useState } from "react"
import useDeviceTheme from "@project/shared/src/useDeviceTheme"

const Wrapper = styled.div`
  height: 345px;
  max-width: 310px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  color: ${(props) => props.theme.base};
  @media (max-width: 1350px) {
    max-width: 100%;
    width: 100%;
    height: auto;
  }
`

const IconStyle = styled.div<{ isLightTheme: boolean }>`
  background-color: #202534;
  border-radius: 20px;
  padding: 20px;
  z-index: 2;
  border: ${({ isLightTheme }) =>
    !isLightTheme ? "1px solid #DDDDDD" : "none"} !important;
  img {
    height: 40px;
    width: 40px;
  }
  @media (max-width: 1023px) {
    img {
      height: 32px;
      width: 32px;
    }
  }
  :hover {
    background: ${(props) => props.theme.highlightGradient};
  }
`

const TextStyle = styled.div`
  ${(props) => props.theme.typography.paragraph2}
  font-size: 14px;
  font-weight: 400;
  margin-top: 4px;
  line-height: 24px;
  text-align: center;
  white-space: break-spaces;
  color: ${(props) => props.theme.whiteAlpha60};
  @media (max-width: 1350px) {
    line-height: 20px;
    padding: 0px 200px;
    white-space: normal;
    font-size: 12px;
  }
  @media (max-width: 600px) {
    font-size: 14px;
    padding: 0px;
  }
`
const TitleStyle = styled.div`
  ${(props) => props.theme.typography.cardTitle}
  font-size: 18px;
  margin-top: 16px;
  font-weight: 600;
  text-align: center;
  white-space: break-spaces;
  line-height: 24px;
  color: ${(props) => props.theme.sameBase};
  @media (max-width: 1023px) {
    font-size: 14px;
    margin-top: 12px;
  }
  @media (max-width: 600px) {
    font-size: 1rem;
    margin-top: 16px;
  }
`

export const SoftWareDescriptionCard: React.FC<ISoftwareSolutionCard> = ({
  icon,
  content,
  title,
  lightIcon,
}) => {
  const isDarkTheme = useDeviceTheme()
  const [isHovered, setIsHovered] = useState<boolean>(false)

  const handleMouseEnter = () => setIsHovered(true)

  const handleMouseLeave = () => setIsHovered(false)
  return (
    <Wrapper>
      <AosWrapper
        duration={animationProperties.duration + 0.5}
        delay={animationProperties.delay + 0.5}
        animateIn={"animate__fadeInUpBig animate__zoomIn"}
        style={{ zIndex: 2 }}
      >
        <IconStyle
          isLightTheme={isDarkTheme}
          className={"icon-inner"}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {isDarkTheme || isHovered ? icon : lightIcon}
        </IconStyle>
      </AosWrapper>

      <TitleStyle>{title}</TitleStyle>
      <TextStyle>{content}</TextStyle>
    </Wrapper>
  )
}
